import React, { useState, useEffect } from 'react';
import queryString from 'query-string';

import { openrtbOffLogList } from 'lib/api/openrtb';

import FilterWrap from 'components/atoms/FilterWrap';
import TableContainer from 'components/molecules/MbTable';
import StatisticsCommonFilter from 'components/organisms/StatisticsCommonFilter';

let initialization = false;
// 공통 필터에서 초기값 받아왔는지 확인
let getInitParam = false;
const OffListStatistics = () => {
  // const { t } = useTranslation();
  const { mediaScriptNo, itlTpCode } = queryString.parse(
    window.location.search
  );
  const initParam = { mediaScriptNo: mediaScriptNo, itlTpCode: itlTpCode };
  const [params, setParams] = useState(initParam);

  useEffect(() => {
    // 렌더링 후에 실행됨
    // params setting(필터링 혹은 초기 param setting) > 렌더링 > 초기화 값 초기화
    initialization = false;
  }, [params]);

  // header 및 body 컬럼 커스텀
  const customized = {
    REG_USER_ID: {
      merged: true,
    },
  };

  /**
   * 필터 초기화
   */
  const handleOnReset = () => {
    initialization = true;
    setParams(initParam);
  };

  const getParam = (newParams) => {
    getInitParam = true;
    setParams({
      ...params,
      ...newParams,
    });
  };

  return (
    <>
      <FilterWrap handleOnReset={handleOnReset}>
        <StatisticsCommonFilter
          initialization={initialization}
          getParam={getParam}
          nonePltfomTpCodeFilter={true}
          noneDisplayFilter={true}
          noneExternalFilter={true}
          noneDate={true}
        />
      </FilterWrap>
      {getInitParam && (
        <>
          <TableContainer
            dataReqPromise={openrtbOffLogList}
            params={{ ...params }}
            sort="desc"
            order="STATS_DTTM"
            dense={true}
            customized={customized}
            hasExcel
            noneSearch
          />
        </>
      )}
    </>
  );
};

export default OffListStatistics;
